<template>
  <div id="app">
    <TopBar v-if="showNavBar"></TopBar>
    <NavBar v-if="showNavBar"></NavBar>
    <div class="content" :style="styleObject">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import TopBar from './components/TopBar/TopBar.vue'
import NavBar from './components/NavBar/NavBar.vue'

export default {
  name: 'App',
  components: {
    TopBar,
    NavBar
  },
  data() {
    return {
      listThemeParamKey: 'listThemeColor'
      //?listThemeColor=%23F56C6C (URL-encode #) 
    }
  },
  computed: {
    // 根据URL参数判断是否显示TopBar和NavBar
    showNavBar() {
      // 如果URL中有fullscreen参数且值为true，则不显示
      // 例如: ?fullscreen=true
      const hideNav = this.$route.query.fullscreen === 'true'
      return !hideNav
    },
    styleObject() {
      // 登录页面或隐藏导航栏时，content撑满屏幕
      if (this.$route.path === '/login' || !this.showNavBar) {
        return {
          top: '0px',
          left: '0px',
          bottom: '0px',
          right: '0px',
          padding: 0
        }
      }
    }
  },
  created() {
    this.applyListThemeFromRoute(this.$route)
  },
  watch: {
    $route: {
      immediate: true,
      handler(newRoute) {
        this.applyListThemeFromRoute(newRoute)
      }
    }
  },
  beforeDestroy() {
    this.resetListTheme()
  },
  methods: {
    applyListThemeFromRoute(route) {
      const themeQueryValue = route && route.query ? route.query[this.listThemeParamKey] : null
      const parsedColor = this.normalizeColor(themeQueryValue)
      if (parsedColor) {
        this.setListTheme(parsedColor)
      } else {
        this.resetListTheme()
      }
    },
    normalizeColor(rawValue) {
      if (!rawValue) {
        return null
      }
      let decodedValue = ''
      try {
        decodedValue = decodeURIComponent(rawValue)
      } catch (e) {
        decodedValue = rawValue
      }
      const candidate = decodedValue.trim()
      if (!candidate) {
        return null
      }
      const cssSupports = typeof CSS !== 'undefined' && CSS.supports
      const isValidColor = cssSupports ? CSS.supports('color', candidate) : /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(candidate)
      return isValidColor ? candidate : null
    },
    setListTheme(color) {
      const root = document.documentElement
      root.style.setProperty('--list-theme-color', color)
      root.classList.add('list-theme-active')
    },
    resetListTheme() {
      const root = document.documentElement
      root.style.removeProperty('--list-theme-color')
      root.classList.remove('list-theme-active')
    }
  }

}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#app
  width:100%;
  height:100%;
  .content
    position:absolute;
    top:62px;
    left:224px;
    right:10px;
    bottom:10px;
    padding:14px 16px;
    overflow:auto;
    background #fff;

:root.list-theme-active
  --list-theme-color: #409EFF;

:root.list-theme-active .el-table__header-wrapper th,
:root.list-theme-active .el-table__fixed-header-wrapper th
  background-color: var(--list-theme-color) !important;
  color:#fff !important;
  border-color: var(--list-theme-color) !important;




:root.list-theme-active .el-tag--light,
:root.list-theme-active .el-pagination.is-background .el-pager li.active
  background-color: var(--list-theme-color) !important;
  border-color: var(--list-theme-color) !important;
  color:#fff !important;

:root.list-theme-active  .el-pager li.active
  color: var(--list-theme-color) !important;
:root.list-theme-active  .el-pager li:hover
  color: var(--list-theme-color) !important;
:root.list-theme-active  .el-tag--plain
  cursor: pointer !important;
  border-color: var(--list-theme-color) !important;
  color: var(--list-theme-color) !important;
  
  
</style>



// WEBPACK FOOTER //
// src/App.vue